import { render, staticRenderFns } from "./App.vue?vue&type=template&id=5e4e5d30&"
import script from "./App.vue?vue&type=script&setup=true&lang=js&"
export * from "./App.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=5e4e5d30&prod&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.10.2_5vnqe6ki2sanoyabgtnvrkv4ju/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports